import React, { useEffect, useState } from 'react';
import OneClickBookingScreen from './OneClickBookingScreen';
import type { InstantBooking } from '../services/instantBookingService';
import { UnifiedAuthService } from '../services/unifiedAuthService';

interface GuestDirectBookingScreenProps {
  onBack: () => void;
  onBookingComplete?: (booking: InstantBooking) => void;
}

/** Guest booking starting at category → business → service (no pre-selected business). */
const GuestDirectBookingScreen: React.FC<GuestDirectBookingScreenProps> = ({
  onBack,
  onBookingComplete,
}) => {
  const [authUser, setAuthUser] = useState<any>(null);

  useEffect(() => {
    UnifiedAuthService.getCurrentUser()
      .then((u) => {
        if (u) {
          setAuthUser(u);
        }
      })
      .catch(() => {
        /* guest */
      });
  }, []);

  const userId = authUser?.id || authUser?.uid || 'guest_app';

  return (
    <OneClickBookingScreen
      guestMode
      onBack={onBack}
      userId={userId}
      user={authUser || undefined}
      onGuestAuthenticated={setAuthUser}
      onBookingComplete={onBookingComplete}
    />
  );
};

export default GuestDirectBookingScreen;
